import React, { useCallback, useState, useMemo } from "react";
import { DateTime } from "luxon";
import { AgGridReact, DatePicker } from "@jsq/ds/core";
import { datePickerFilterWrapper, filterText } from "../styles_vanilla.css";
import { DEFAULT_EARLIEST_EFFECTIVE_DATE } from "./constants";

export const DistributionDateFilter = (filterParams: AgGridReact.CustomFilterProps) => {
  const { onModelChange } = filterParams;
  const [value, setValue] = useState<string>(DEFAULT_EARLIEST_EFFECTIVE_DATE);

  const handleChange = useCallback(
    (date: Date | null) => {
      if (date) {
        const isoDate = DateTime.fromJSDate(date).toISODate();
        setValue(isoDate ?? "");
        onModelChange({ date: isoDate ?? null });
      } else {
        setValue("");
        onModelChange({ date: null });
      }
    },
    [onModelChange],
  );

  const selectedDate = useMemo(() => {
    if (!value) return null;
    return DateTime.fromISO(value).toJSDate();
  }, [value]);

  AgGridReact.useGridFilter({ doesFilterPass: () => true });

  return (
    <DatePicker
      className={filterText}
      wrapperClassName={datePickerFilterWrapper}
      isClearable
      selected={selectedDate}
      onChange={handleChange}
      dateFormat="MMM d, yyyy"
      placeholderText="Select date"
    />
  );
};
